import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Apakah ada biaya untuk pengecekan laptop?',
      answer: 'Tidak ada biaya sama sekali! Kami memberikan layanan pengecekan laptop GRATIS untuk semua pelanggan. Anda hanya perlu membayar jika setuju dengan estimasi biaya perbaikan yang kami berikan.'
    },
    {
      question: 'Berapa lama waktu pengerjaan servis laptop?',
      answer: 'Waktu pengerjaan bervariasi tergantung jenis kerusakan. Untuk install ulang biasanya 2-4 jam, ganti LCD/keyboard 1-2 hari, dan perbaikan motherboard 3-7 hari. Kami akan memberikan estimasi waktu yang jelas setelah pengecekan.'
    },
    {
      question: 'Apakah ada garansi untuk servis yang dilakukan?',
      answer: 'Ya, kami memberikan garansi pengerjaan 2-5 bulan untuk servis tertentu seperti ganti LCD, keyboard, baterai, dan perbaikan hardware lainnya. Garansi tidak berlaku untuk kerusakan akibat benturan atau air setelah servis.'
    },
    {
      question: 'Apakah bisa pesan cetak foto secara online?',
      answer: 'Tentu bisa! Anda dapat mengirimkan file foto melalui WhatsApp ke 0858-6836-0910. Sebutkan ukuran dan jumlah yang diinginkan, lalu kami akan konfirmasi total biaya. Foto bisa diambil di toko atau diantar (untuk area Warungasem).'
    },
    {
      question: 'Berapa minimal order untuk cetak stiker?',
      answer: 'Untuk cetak stiker A3 minimal order 1 lembar saja sudah bisa. Untuk stiker label makanan atau stiker custom, minimal order biasanya 50-100 pcs tergantung ukuran. Silakan konsultasi untuk detail harga.'
    },
    {
      question: 'Apakah melayani pemasangan CCTV di luar Warungasem?',
      answer: 'Ya, kami melayani pemasangan CCTV untuk area Batang dan sekitarnya. Untuk area di luar Batang, akan ada biaya transportasi tambahan. Hubungi kami untuk survey lokasi dan konsultasi gratis.'
    },
    {
      question: 'Bagaimana cara memesan undangan digital website?',
      answer: 'Sangat mudah! Hubungi kami via WhatsApp, pilih tema yang Anda suka, kirimkan data acara dan foto. Kami akan buatkan website undangan dalam 2-3 hari kerja. Anda bisa revisi sampai puas sebelum dipublish.'
    },
    {
      question: 'Apakah bisa konsultasi dulu sebelum order?',
      answer: 'Sangat bisa! Kami sangat menyarankan untuk konsultasi terlebih dahulu agar kami bisa memberikan solusi terbaik sesuai kebutuhan dan budget Anda. Konsultasi gratis via WhatsApp atau datang langsung ke toko kami.'
    },
    {
      question: 'Metode pembayaran apa saja yang diterima?',
      answer: 'Kami menerima pembayaran tunai, transfer bank (BCA, BRI, Mandiri), dan e-wallet (GoPay, OVO, Dana, ShopeePay). Untuk project besar bisa DP 50% di awal dan pelunasan setelah selesai.'
    },
    {
      question: 'Apakah ada paket bundling atau diskon khusus?',
      answer: 'Ya! Kami sering memberikan paket bundling untuk beberapa layanan, misalnya paket CCTV + instalasi, paket cetak foto + frame, atau paket desain + cetak. Untuk order dalam jumlah banyak atau pelanggan setia juga ada harga khusus. Tanyakan promo terbaru kami!'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
              FAQ
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
            Pertanyaan yang Sering Diajukan
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Temukan jawaban untuk pertanyaan umum tentang layanan kami
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-xl"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                >
                  <div className="flex items-start gap-4 flex-1">
                    <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                      openIndex === index 
                        ? 'bg-gradient-to-br from-[#FF8A00] to-orange-600' 
                        : 'bg-gray-100'
                    }`}>
                      <i className={`ri-question-line text-xl ${
                        openIndex === index ? 'text-white' : 'text-gray-600'
                      }`}></i>
                    </div>
                    <h3 className={`text-lg font-semibold transition-colors duration-200 ${
                      openIndex === index ? 'text-[#FF8A00]' : 'text-[#0B1F3B]'
                    }`}>
                      {faq.question}
                    </h3>
                  </div>
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                    openIndex === index 
                      ? 'bg-[#FF8A00] rotate-180' 
                      : 'bg-gray-100'
                  }`}>
                    <i className={`ri-arrow-down-s-line text-xl ${
                      openIndex === index ? 'text-white' : 'text-gray-600'
                    }`}></i>
                  </div>
                </button>
                
                <div
                  className={`transition-all duration-300 ease-in-out ${
                    openIndex === index 
                      ? 'max-h-96 opacity-100' 
                      : 'max-h-0 opacity-0'
                  } overflow-hidden`}
                >
                  <div className="px-6 pb-6 pl-20">
                    <p className="text-gray-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] rounded-3xl p-8 text-center shadow-2xl">
            <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-full mx-auto mb-4">
              <i className="ri-customer-service-2-line text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">
              Masih Ada Pertanyaan?
            </h3>
            <p className="text-white/80 mb-6 max-w-xl mx-auto">
              Tim kami siap membantu menjawab semua pertanyaan Anda. Jangan ragu untuk menghubungi kami!
            </p>
            <a
              href="https://wa.me/6285868360910"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#FF8A00] text-white px-8 py-4 rounded-xl font-semibold hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Hubungi via WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
